import { codeEditorTyping } from '../../editor-typing.generated';
import { AutomationClientPortalWorkflowCodeActionEnum } from './client-portal-workflow-code-action.enum';

export const clientPortalWorkflowCodeEditorTyping = codeEditorTyping(
  AutomationClientPortalWorkflowCodeActionEnum,
);
